import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { CONFIRM } from '../api';

export default {
    namespaced: true,
    state: request_state,
    mutations: request_mutations('confirm'),
    actions: {
        confirm({ commit }, code) {
            commit('confirm_loading');
            axios.post(CONFIRM, { confirmation_code: code }).then((response) => {
                commit('confirm_success', response.data);
                commit('user/set_token', response.data.token, { root: true });
                commit('user/set_user', response.data.user, { root: true });
            }).catch(error => commit('confirm_error', error.response ? error.response.data : {}));
        },
    },
};
